import module from 'empresa/module.js'
import template from './template.html'

export default class EmpresaCuentaDocumentosEliminarComponent {
  constructor (EmpresaCuentaDocumento) {
    this.EmpresaCuentaDocumento = EmpresaCuentaDocumento
    this.documento = null
    this.onClose = null
    this.eliminando = false
  }

  eliminar () {
    if (this.eliminando) return

    this.eliminando = true

    this.EmpresaCuentaDocumento.delete(this.documento.id_empresa, this.documento.id_cuenta, this.documento.id)
      .then(() => (this.onClose({$event: {data: this.documento}})))
      .finally(() => (this.eliminando = false))
  }

  cerrar () {
    this.onClose()
  }
}

module.component('empresaCuentaDocumentosEliminar', {
  controller: EmpresaCuentaDocumentosEliminarComponent,
  template,
  bindings: {
    documento: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/cuenta/documentos/eliminar/component.js